/**
 * SpaceViewPage - Shareable space viewer
 *
 * Handles clean shareable URLs like:
 * - /space/{gameId}
 * - /s/{gameId}
 *
 * GameStepPage reads its game id ONLY from the query string (?gameId=…) — it
 * accepts no id prop — so this wrapper redirects to the canonical URL instead
 * of rendering the page directly. (08-11: the old prop pass-through
 * <GameStepPage initialGameId={…}> silently loaded nothing — the props were
 * never destructured — and its getGameById preflight was dead work whose
 * result was discarded on every branch.)
 */

import React from 'react';
import { useParams, useSearchParams, Navigate } from 'react-router-dom';

const SpaceViewPage = () => {
  const { gameId } = useParams();
  const [searchParams] = useSearchParams();

  if (!gameId) return <Navigate to="/" replace />;

  // Carry every query param through (playerId etc.) — only the path form changes
  const params = new URLSearchParams(searchParams);
  params.set('gameId', gameId);
  return <Navigate to={`/game-step?${params.toString()}`} replace />;
};

export default SpaceViewPage;
